import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** Dashboard paths organizers may open (direct URL or refresh). */
export const ORGANIZER_ALLOWED_PATHS = new Set([
  '/dashboard',
  '/dashboard/attendance',
  '/dashboard/payments',
  '/dashboard/logistics',
  '/dashboard/driver-pickup',
]);

/**
 * Organizers are limited to a subset of dashboard routes. Others redirect home (/dashboard).
 */
const OrganizerPathGuard = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const role = typeof user?.role === 'string' ? user.role.toLowerCase().trim() : '';

  if (role !== 'organizer') {
    return children;
  }

  const path = location.pathname.replace(/\/+$/, '') || '/dashboard';
  if (!ORGANIZER_ALLOWED_PATHS.has(path)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default OrganizerPathGuard;
